import clsx from 'clsx'

type Props = {
  onClick?: () => void
  className?: string
  href?: string
  variant?: 'light' | 'dark'
}
export function BrandLogo({ onClick, href, variant = 'light', className }: Props) {
  const style = { fontFamily: 'Gilroy', color: variant == 'light' ? '#484F75' : 'white' }
  const classes = clsx(
    'cursor-pointer text-2xl',
    variant == 'light' ? 'font-black' : 'font-bold',
    className
  )

  if (href) {
    return (
      <a href={href} style={style} className={classes} onClick={onClick}>
        StanfordTa<span style={{ color: '#536CF1' }}>x</span>
      </a>
    )
  }

  return (
    <span style={style} className={classes} onClick={onClick}>
      StanfordTa<span style={{ color: '#536CF1' }}>x</span>
    </span>
  )
}

export function BrandLogoIcon() {
  return (
    <div
      className="flex size-12 flex-col items-center justify-center rounded-md bg-gray-900 text-2xl shadow-md"
      style={{ fontFamily: 'Gilroy' }}
    >
      <div>
        <span className="text-white">S</span>
        <span className="text-blue-400">T</span>
      </div>
    </div>
  )
}
